export type SectionName = 'listening' | 'speaking' | 'reading' | 'writing' | 'grammar_vocabulary'
export const SECTION_NAME_MAP: { [k in SectionName]: string } = {
  grammar_vocabulary: 'Grammar & Vocabulary',
  listening: 'Listening',
  reading: 'Reading',
  speaking: 'Speaking',
  writing: 'Writing'
}

export const SECTION_LIST: SectionName[] = [
  "listening",
  "reading",
  "speaking",
  "writing"
]